import {
  Activity,
  Building2,
  CalendarRange,
  ChartLine,
  Headset,
  HeartPulse,
  Layers,
  Palmtree,
  Scan,
  Stethoscope,
  Table2,
  Telescope,
  UserPlus,
  Users,
  Workflow,
} from "lucide-react";

import { ROUTES } from "@/lib/routes";
import type { NavItem } from "@/components/nav/types/nav";

/** The "Workspace" group: the day-to-day pages. */
export const WORKSPACE_ITEMS: NavItem[] = [
  { to: ROUTES.HOME, label: "Schedule", icon: CalendarRange, permission: "view_schedule" },
  { to: ROUTES.OUTPATIENT, label: "Outpatient", icon: HeartPulse, permission: "view_schedule" },
  { to: ROUTES.VACATIONS, label: "Vacations", icon: Palmtree, permission: "manage_vacations" },
  { to: ROUTES.SUPPORT_SCHEDULE, label: "Support", icon: Headset, permission: "view_support_schedule" },
  { to: ROUTES.FORECAST, label: "Forecast", icon: Telescope, permission: "view_forecast" },
  { to: ROUTES.ANALYTICS, label: "Analytics", icon: ChartLine, permission: "view_analytics" },
  { to: ROUTES.ROSTER, label: "Roster", icon: Table2, permission: "view_roster" },
  { to: ROUTES.ONBOARDING, label: "Onboarding", icon: UserPlus, permission: "manage_onboarding_invites" },
];

/** The "Settings" group: configuration, hidden entirely when none are visible. */
export const SETTINGS_ITEMS: NavItem[] = [
  { to: ROUTES.RADIOLOGISTS, label: "Radiologists", icon: Stethoscope, permission: "manage_settings" },
  { to: ROUTES.RAD_SUPPORT, label: "Rad Support", icon: Headset, permission: "manage_rad_support" },
  { to: ROUTES.SITES, label: "Facilities", icon: Building2, permission: "manage_settings" },
  { to: ROUTES.SPECIALTIES, label: "Specialties", icon: Layers, permission: "manage_settings" },
  { to: ROUTES.STUDIES, label: "Studies", icon: Scan, permission: "manage_studies" },
  { to: ROUTES.AUTOMATION, label: "Automation", icon: Workflow, godOnly: true },
  { to: ROUTES.TI_TELEMETRY, label: "TI Telemetry", icon: Activity, godOnly: true },
  { to: ROUTES.USERS, label: "Users", icon: Users, permission: "manage_users" },
];
